<template>
  <section class="hero" :aria-label="$t('hero.aria')">
    <transition name="hero-fade" mode="out-in">
      <img :key="`image-${current}`" class="hero-img" :src="imageUrl(active.imageUrl)" :alt="active.title">
    </transition>
    <div class="hero-shade"></div>
    <div class="hero-copy">
      <p class="eyebrow">VERVESTEEL / PROFESSIONAL KITCHENS</p>
      <h1 v-if="englishTitle"><span class="outline-title">{{ titleLines[0] }}</span><span>{{ titleLines[1] }}</span></h1>
      <h1 v-else><span>{{ active.title }}</span></h1>
      <p class="hero-description" v-html="subtitleHtml"></p>
      <a v-if="nativeLink" class="button" :href="activeLink" :target="newWindow ? '_blank' : null" :rel="newWindow ? 'noopener noreferrer' : null">{{ $t('hero.explore') }} <span>↗</span></a>
      <router-link v-else class="button" :to="activeLink">{{ $t('hero.explore') }} <span>↗</span></router-link>
    </div>
    <div class="hero-bottom">
      <div class="slide-controls">
        <span>{{ String(current + 1).padStart(2, '0') }} / {{ String(slides.length).padStart(2, '0') }}</span>
        <button v-for="(slide, index) in slides" :key="index" class="slide-dot" :class="{ active: index === current }" type="button" :aria-pressed="String(index === current)" :aria-label="$t('hero.slide', { number: index + 1 })" @click="go(index)">{{ String(index + 1).padStart(2, '0') }}</button>
      </div>
      <span>VALUE THROUGH STRENGTH</span>
      <a href="#about">{{ $t('hero.down') }} ↓</a>
    </div>
  </section>
</template>

<script>
import { getBanners, resolveAssetUrl } from '../api/public'
import { homeSlides } from '../data/site'

export default {
  name: 'HomeHero',
  data() { return { slides: [], current: 0, timer: null } },
  computed: {
    fallbackSlides() {
      if (this.$i18n.locale === 'zh-CN') return homeSlides
      return [{ title: 'VERVESTEEL', subtitle: this.$t('home.oneStop'), imageUrl: homeSlides[0].imageUrl, linkUrl: '/solutions' }]
    },
    active() { return this.slides[this.current] || this.fallbackSlides[0] },
    englishTitle() { return /^[A-Z\s&]+$/.test(this.active.title || '') && (this.active.title || '').trim().split(/\s+/).length > 1 },
    titleLines() { const words = (this.active.title || '').trim().split(/\s+/); return [words.slice(0, -1).join(' '), words[words.length - 1]] },
    subtitleHtml() { return String(this.active.subtitle || '').replace(/\n/g, '<br>') },
    activeLink() { return this.slideLink(this.active.linkUrl) },
    nativeLink() { return /^(?:https?:|mailto:|tel:|\/\/)/i.test(this.activeLink) || /\.pdf(?:[?#]|$)/i.test(this.activeLink) },
    newWindow() { return /^(?:https?:|\/\/)/i.test(this.activeLink) || /\.pdf(?:[?#]|$)/i.test(this.activeLink) }
  },
  watch: { '$i18n.locale': 'loadSlides' },
  async mounted() {
    await this.loadSlides()
    this.start()
  },
  beforeDestroy() { clearInterval(this.timer) },
  methods: {
    async loadSlides() {
      try {
        const data = await getBanners('HOME')
        const isLegacySeed = data?.length === 1 && data[0].title === '专业厨房设备，一站式整体解决方案'
        this.slides = data?.length && !isLegacySeed ? data : this.fallbackSlides
        this.current = 0
      } catch (error) { this.slides = this.fallbackSlides }
    },
    imageUrl(url) { return resolveAssetUrl(url, homeSlides[0].imageUrl) },
    go(index) { this.current = index; this.start() },
    start() { clearInterval(this.timer); this.timer = setInterval(() => { this.current = (this.current + 1) % this.slides.length }, 6500) },
    slideLink(url) {
      const value = String(url || '').trim()
      if (!value || value === '#' || /^javascript:/i.test(value)) return '/solutions'
      if (/^(?:https?:|mailto:|tel:|\/\/)/i.test(value)) return value
      const internal = value.startsWith('/') ? value : `/${value}`
      return internal.replace(/^\/index\.html(?=[?#]|$)/, '/').replace(/\.html(?=[?#]|$)/, '')
    }
  }
}
</script>
